/**
 * apiBase — HANGİ BACKEND'E GİDİYORUZ (TEK-5, 29 Ağu 2026)
 *
 * NEDEN VAR
 * ---------
 * Backend adresi bugüne kadar DERLEME ZAMANI sabitiydi
 * (`process.env.REACT_APP_BACKEND_URL`, altı ayrı dosyada). İki ayrı derleme
 * vardı: sokakkedileri.tr Türkiye API'sine, straypaw.ai StrayPaw API'sine.
 *
 * 28 Ağustos'ta Apple, StrayPaw'ı 4.3(a) — aynı uygulamanın ikinci bundle'ı —
 * gerekçesiyle reddetti. Kuralın istediği şey tek uygulama. Tek uygulama ise
 * iki backend'e bakabilmek zorunda: ülke çalışma zamanında seçiliyor
 * (`getCountry()`), adres de onunla birlikte seçilmeli.
 *
 * VERİ İKAMETGÂHI DEĞİŞMİYOR. Türkiye'nin verisi Türkiye veritabanında,
 * Endonezya'nınki kendi veritabanında kalmaya devam ediyor — ayrı Mongo, ayrı
 * R2 kovası, ayrı Render servisi. Değişen tek şey, seçimin derlemeden çalışma
 * zamanına taşınması.
 *
 * OTURUM UYARISI
 * --------------
 * Jeton (token) BİR BACKEND'E aittir. Türkiye'de alınan jeton StrayPaw
 * sunucusunda geçersizdir. Ülke değişince jeton da temizlenmeli, yoksa
 * kullanıcı sessizce kırık bir oturumda kalır: `/auth/me` 401 döner, uygulama
 * onu çıkış yapmış sanır ama nedenini söyleyemez. `oturumUlkesiniDenetle()`
 * bunu tek yerde çözüyor.
 */
import { getCountry } from "./country";

/**
 * Ülke → backend. Adresler GİZLİ DEĞİL (herkese açık API uçları), bu yüzden
 * kodda durabilirler; ortam değişkeni verilirse o kazanır ki önizleme ve yerel
 * geliştirme kırılmasın.
 */
const TR_BACKEND =
  process.env.REACT_APP_BACKEND_URL_TR || "https://sokakkedileri-api.onrender.com";
const INTL_BACKEND =
  process.env.REACT_APP_BACKEND_URL_INTL || "https://straypaw-api.onrender.com";

/**
 * GERİYE UYUMLULUK: eski tek adresli derlemeler (`REACT_APP_BACKEND_URL`).
 * Yerel geliştirmede `http://localhost:8001` verildiğinde ülke ne olursa olsun
 * ona gitmeliyiz — aksi halde geliştirici canlıya bağlanır.
 */
const TEK_ADRES = process.env.REACT_APP_BACKEND_URL || "";
const YEREL = /^https?:\/\/(localhost|127\.0\.0\.1|0\.0\.0\.0)(:|\/|$)/i.test(TEK_ADRES);

/**
 * KURULUM ADRESİ — geriye dönük güvenlik ağı (29 Ağu 2026, ilk sürümde YOKTU).
 *
 * İlk yazımda üretim adresi doğrudan `getCountry()`'ye bağlanmıştı. Cloudflare'ı
 * kontrol edince ortaya çıktı: `straypaw` projesinde `REACT_APP_DEFAULT_COUNTRY`
 * ayarlı ama **`sokakkedileri` projesinde YOK.** Yani sokakkedileri.tr ülkeyi
 * cihaz dilinden tahmin edecekti; tarayıcısı İspanyolca/Endonezce/Lehçe olan bir
 * ziyaretçi StrayPaw veritabanına düşüp 134 kedi yerine boş site görecekti.
 *
 * Hata şuydu: üretim davranışını, o güne kadar GEREKLİ OLMAYAN bir değişkenin
 * varlığına bağladım. Doğrusu, kurulumun kendi adresini varsayılan kabul etmek:
 *
 *   1. Kullanıcı ülkesini AÇIKÇA seçtiyse  → ülke belirler (tek uygulamanın amacı)
 *   2. Seçmediyse ve derlemede adres varsa → o adres (bugünkü davranışın aynısı)
 *   3. Hiçbiri yoksa                       → ülke haritası
 *
 * Böylece TEK-5 mevcut hiçbir kurulumun davranışını değiştirmiyor; ayrışma
 * ancak kullanıcı ülkesini kendi seçtiğinde başlıyor.
 */
const KURULUM_ADRESI = YEREL ? "" : TEK_ADRES;

function ulkeSecilmisMi() {
  try {
    return Boolean(localStorage.getItem("sk_country"));
  } catch (e) {
    return false;
  }
}

function temizle(u) {
  return String(u || "").trim().replace(/\/+$/, "");
}

/** Aktif ülkenin backend kökü (sonunda `/api` YOK). */
export function backendRoot(ulke) {
  if (YEREL) return temizle(TEK_ADRES);
  // Açık argüman her şeyi geçer (testler ve bilinçli çağrılar).
  if (!ulke && KURULUM_ADRESI && !ulkeSecilmisMi()) return temizle(KURULUM_ADRESI);
  const c = String(ulke || getCountry() || "").toLowerCase();
  return temizle(c === "tr" ? TR_BACKEND : INTL_BACKEND);
}

/** Aktif ülkenin API kökü. Eski `const API = ...` satırlarının yerine geçer. */
export function apiBase(ulke) {
  return `${backendRoot(ulke)}/api`;
}

// ── Oturum ↔ ülke bağı ────────────────────────────────────────────────────
const OTURUM_ULKE_ANAHTARI = "sk_token_country";

/** Giriş başarılı olduğunda jetonun hangi ülkeye ait olduğunu damgala. */
export function oturumUlkesiniDamgala(ulke) {
  try {
    localStorage.setItem(OTURUM_ULKE_ANAHTARI, String(ulke || getCountry() || ""));
  } catch (e) {
    /* depolama kapalı — damga yoksa denetim de sessizce geçer */
  }
}

/**
 * MEVCUT KULLANICI GÖÇÜ — sessiz bir regresyonu kapatır.
 *
 * Bu sürümden önce adres `.env`'den geliyordu: native uygulama cihaz dili ne
 * olursa olsun HEP aynı backend'e gidiyordu. Artık adres `getCountry()`'den
 * geliyor ve o, depolamada seçim yoksa CİHAZ DİLİNE düşüyor.
 *
 * Somut tehlike: telefonu İspanyolca olan bir Türk kullanıcı `"es"` alır —
 * `SUPPORTED_COUNTRIES` içinde olduğu için geçerli sayılır — ve güncellemeden
 * sonra StrayPaw backend'ine gider. Hesabı, kedileri, mesajları "kaybolur".
 * Aslında kaybolmadı, yanlış veritabanına bakıyor.
 *
 * Çözüm: elinde jeton olup ülke seçimi OLMAYAN kullanıcı, uygulamanın ESKİDEN
 * gittiği ülkeye sabitlenir. Yeni kullanıcılar ülkeyi zaten ekranda seçecek.
 */
const DERLEME_ULKESI = (process.env.REACT_APP_DEFAULT_COUNTRY || "tr")
  .trim()
  .toLowerCase();

/** Sabitlediyse sabitlenen ülke kodunu, sabitlemediyse null döner. */
export function mevcutKullaniciyiSabitle() {
  try {
    if (!localStorage.getItem("token")) return null;
    if (localStorage.getItem("sk_country")) return null;      // zaten seçmiş
    if (localStorage.getItem(OTURUM_ULKE_ANAHTARI)) return null; // zaten damgalı
    localStorage.setItem("sk_country", DERLEME_ULKESI);
    localStorage.setItem(OTURUM_ULKE_ANAHTARI, DERLEME_ULKESI);
    return DERLEME_ULKESI;
  } catch (e) {
    return null;
  }
}

/**
 * Jeton başka bir ülkeye aitse SİL ve true dön.
 *
 * Önce göç adımı çalışır: damgasız eski kullanıcılar eski ülkelerine
 * sabitlenir, dolayısıyla bu denetimden etkilenmezler. Damga varsa ve ülke
 * değişmişse jeton temizlenir — o jeton diğer backend'de geçersiz.
 */
export function oturumUlkesiniDenetle() {
  try {
    // Göç bu çağrıda çalıştıysa jetonun hangi ülkeye ait olduğunu ARTIK
    // BİLİYORUZ — `getCountry()`'yi tekrar okumaya gerek yok ve okumamalıyız.
    // Örtük bağımlılıktı: göç `sk_country`'yi yazıyor, denetim onu geri
    // okuyacağını varsayıyordu. Testte yakalandı.
    if (mevcutKullaniciyiSabitle()) return false;
    const jeton = localStorage.getItem("token");
    if (!jeton) return false;
    const damga = localStorage.getItem(OTURUM_ULKE_ANAHTARI);
    if (!damga) return false;
    if (damga === getCountry()) return false;
    localStorage.removeItem("token");
    localStorage.removeItem(OTURUM_ULKE_ANAHTARI);
    return true;
  } catch (e) {
    return false;
  }
}
